module.exports = __webpack_public_path__ + "img/GB.61c413b6.png";